import { render, staticRenderFns } from "./ApprovalWeekly.vue?vue&type=template&id=4f99426a&scoped=true&"
import script from "./ApprovalWeekly.vue?vue&type=script&lang=js&"
export * from "./ApprovalWeekly.vue?vue&type=script&lang=js&"
import style0 from "../SalesForce.scss?vue&type=style&index=0&id=4f99426a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f99426a",
  null
  
)

export default component.exports